interface ICycleTimeFormat {
  success: boolean
  data: number
  message: string | null
}

export const checkCycleTimeFormat = (
  cycleTime: string,
  type: 'Machining time' | 'Load and unload time'
): ICycleTimeFormat => {
  const data: ICycleTimeFormat = {
    success: false,
    data: 0,
    message: null
  }
  const cycleTimeString = String(cycleTime)

  //1. Check if the string includes :
  if (!cycleTimeString.includes(':')) {
    data.success = false
    data.message = `Missing ':' ${type} should be in mm:ss format`
    return data
  }

  const arr = cycleTimeString.split(':')

  if (type === 'Machining time' && arr.length !== 3) {
    data.success = false
    data.message = `${type} should be in mm:ss:SSS format`
    return data
  }

  if (type === 'Load and unload time' && arr.length !== 2) {
    data.success = false
    data.message = ` ${type} should be in mm:ss format`
    return data
  }

  if (Number(arr[0]) >= 60) {
    data.success = false
    data.message = `Minutes should be less than 60 in ${type}`
    return data
  }

  if (Number(arr[1]) >= 60) {
    data.success = false
    data.message = `Seconds should be less than 60 in ${type}`
    return data
  }

  if (type === 'Machining time' && Number(arr[2]) >= 999) {
    data.success = false
    data.message = `Milliseconds should be less than 999 in ${type}`
    return data
  }

  return {
    ...data,
    success: true,
    data: Number(arr[0]) * 60 + Number(arr[1])
  }
}
